import React, { Component } from 'react';
import { isMobileBrowser } from '../../../base/environment/utils';
import { translate } from '../../../base/i18n/functions';
import { IconSend } from '../../../base/icons/svg';
import { connect } from '../../../base/redux/functions';
import Button from '../../../base/ui/components/web/Button';
import Input from '../../../base/ui/components/web/Input';
// @ts-ignore
import InputCheckbox from './InputCheckbox';
// @ts-ignore
import ToggleMath from './ToggleMath';
import i18next from "i18next";
class Queue {
    constructor(...params) {
        this.items = [...params];
    }
    enqueue(item) {
        // prevent duplications
        for (const i in this.items) {
            if (item.key === this.items[i].key) {
                return;
            }
        }
        this.items.push(item);
    }
    dequeue() {
        return this.items.shift();
    }
    peek() {
        return this.items[0];
    }
    clear() {
        this.items.length = 0;
    }
    get length() {
        return this.items.length;
    }
    get isEmpty() {
        return this.length === 0;
    }
}
/**
 * Implements a React Component for drafting and submitting a chat message.
 *
 * @augments Component
 */
class ChatInput extends Component {
    /**
     * Initializes a new {@code ChatInput} instance.
     *
     * @param {Object} props - The read-only properties with which the new
     * instance is to be initialized.
     */
    constructor(props) {
        super(props);
        this._inputTh = 50; // 큐 입력을 기다리는 시간 (ms 단위)
        this._procTh = 15; // 동시 입력 처리  -> _inputTh와 _proTh는 2배 초과 차이가 나야 함 (_inputTh > _procTh)
        this.state = {
            message: '',
            showSmileysPanel: false,
            isBraille: false,
            isMath: false,
            inputChoice: '',
            isTrans: false,
        };
        this._textArea = React.createRef();
        this._queue = new Queue();
        this._brailleKeys = ['s', 'd', 'f', 'j', 'k', 'l'];
        this._brailleKeyMap = {
            's': '⠄',
            'd': '⠂',
            'f': '⠁',
            'j': '⠈',
            'k': '⠐',
            'l': '⠠',
            'ds': '⠆',
            'fs': '⠅',
            'js': '⠌',
            'ks': '⠔',
            'ls': '⠤',
            'df': '⠃',
            'dj': '⠊',
            'dk': '⠒',
            'dl': '⠢',
            'fj': '⠉',
            'fk': '⠑',
            'fl': '⠡',
            'jk': '⠘',
            'jl': '⠨',
            'kl': '⠰',
            'dfs': '⠇',
            'djs': '⠎',
            'dks': '⠖',
            'dls': '⠦',
            'fjs': '⠍',
            'fks': '⠕',
            'fls': '⠥',
            'jks': '⠜',
            'jls': '⠬',
            'kls': '⠴',
            'dfj': '⠋',
            'dfk': '⠓',
            'dfl': '⠣',
            'djk': '⠚',
            'djl': '⠪',
            'dkl': '⠲',
            'fjk': '⠙',
            'fjl': '⠩',
            'fkl': '⠱',
            'jkl': '⠸',
            'dfjs': '⠏',
            'dfks': '⠗',
            'dfls': '⠧',
            'djks': '⠞',
            'djls': '⠮',
            'dkls': '⠶',
            'fjks': '⠝',
            'fjls': '⠭',
            'fkls': '⠵',
            'jkls': '⠼',
            'dfjk': '⠛',
            'dfjl': '⠫',
            'dfkl': '⠳',
            'djkl': '⠺',
            'fjkl': '⠹',
            'dfjks': '⠟',
            'dfjls': '⠯',
            'dfkls': '⠷',
            'djkls': '⠾',
            'fjkls': '⠽',
            'dfjkl': '⠻',
            'dfjkls': '⠿'
        };
        this._brailleAsciiTable = {
            ' ': ' ',
            '!': '⠮',
            '"': '⠐',
            '#': '⠼',
            '$': '⠫',
            '%': '⠩',
            '&': '⠯',
            '\'': '⠄',
            '(': '⠷',
            ')': '⠾',
            '*': '⠡',
            '+': '⠬',
            ',': '⠠',
            '-': '⠤',
            '.': '⠨',
            '/': '⠌',
            '0': '⠴',
            '1': '⠂',
            '2': '⠆',
            '3': '⠒',
            '4': '⠲',
            '5': '⠢',
            '6': '⠖',
            '7': '⠶',
            '8': '⠦',
            '9': '⠔',
            ':': '⠱',
            ';': '⠰',
            '<': '⠣',
            '=': '⠿',
            '>': '⠜',
            '?': '⠹',
            '@': '⠈',
            'a': '⠁',
            'b': '⠃',
            'c': '⠉',
            'd': '⠙',
            'e': '⠑',
            'f': '⠋',
            'g': '⠛',
            'h': '⠓',
            'i': '⠊',
            'j': '⠚',
            'k': '⠅',
            'l': '⠇',
            'm': '⠍',
            'n': '⠝',
            'o': '⠕',
            'p': '⠏',
            'q': '⠟',
            'r': '⠗',
            's': '⠎',
            't': '⠞',
            'u': '⠥',
            'v': '⠧',
            'w': '⠺',
            'x': '⠭',
            'y': '⠽',
            'z': '⠵',
            '[': '⠪',
            '\\': '⠳',
            ']': '⠻',
            '^': '⠘',
            '_': '⠸',
            '`': '⠈',
            '{': '⠪',
            '|': '⠳',
            '}': '⠻',
            '~': '⠘',
            '⠀': ' '
        };
        this._brailleList = [
            ' ',
            '⠮',
            '⠐',
            '⠼',
            '⠫',
            '⠩',
            '⠯',
            '⠄',
            '⠷',
            '⠾',
            '⠡',
            '⠬',
            '⠠',
            '⠤',
            '⠨',
            '⠌',
            '⠴',
            '⠂',
            '⠆',
            '⠒',
            '⠲',
            '⠢',
            '⠖',
            '⠶',
            '⠦',
            '⠔',
            '⠱',
            '⠰',
            '⠣',
            '⠿',
            '⠜',
            '⠹',
            '⠈',
            '⠁',
            '⠃',
            '⠉',
            '⠙',
            '⠑',
            '⠋',
            '⠛',
            '⠓',
            '⠊',
            '⠚',
            '⠅',
            '⠇',
            '⠍',
            '⠝',
            '⠕',
            '⠏',
            '⠟',
            '⠗',
            '⠎',
            '⠞',
            '⠥',
            '⠧',
            '⠺',
            '⠭',
            '⠽',
            '⠵',
            '⠪',
            '⠳',
            '⠻',
            '⠘',
            '⠸',
            '⠈',
            '⠪',
            '⠳',
            '⠻',
            '⠘'
        ];
        // Bind event handlers so they are only bound once for every instance.
        this._onDetectSubmit = this._onDetectSubmit.bind(this);
        this._onMessageChange = this._onMessageChange.bind(this);
        // this._onSmileySelect = this._onSmileySelect.bind(this);
        this._onSubmitMessage = this._onSubmitMessage.bind(this);
        // this._toggleSmileysPanel = this._toggleSmileysPanel.bind(this);
        this._onMathChange = this._onMathChange.bind(this);
        this._procKeys = this._procKeys.bind(this);
        this._setCheckBoxAsRadio = this._setCheckBoxAsRadio.bind(this);
        this._onDisabledToggleMath = this._onDisabledToggleMath.bind(this);
    }
    /**
     * Implements React's {@link Component#componentDidMount()}.
     *
     * @inheritdoc
     */
    componentDidMount() {
        var _a;
        const roomId = location.pathname;
        const selectChatMode = document.getElementById('selectChatMode');
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "GET",
            headers: { 'Content-Type': 'application/json' }
        }).then(res => {
            if (res.status == 200) {
                res.json().then(data => {
                    if (!data.serviceForVisionLoss) {
                        //@ts-ignore
                        selectChatMode.style.display = 'none';
                    }
                    else {
                        //@ts-ignore
                        selectChatMode.style.display = 'flex';
                    }
                });
            }
        });
        // @ts-ignore
        APP.keyboardshortcut.registerShortcut('M', 'toggleMath', this._onMathChange, 'keyboardShortcuts.toggleMath', true);
        if (isMobileBrowser()) {
            // Ensure textarea is not focused when opening chat on mobile browser.
            ((_a = this._textArea) === null || _a === void 0 ? void 0 : _a.current) && this._textArea.current.blur();
        }
        setInterval(this._procKeys, this._procTh);
    }
    componentWillUnmount() {
        // @ts-ignore
        APP.keyboardshortcut.unregisterShortcut('M', true);
    }
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        return (React.createElement("div", { className: `chat-input-container${this.state.message.trim().length ? ' populated' : ''}` },
            React.createElement("fieldset", { id: 'selectChatMode', style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    padding: '5px',
                    backgroundColor: 'black'
                } },
                React.createElement(InputCheckbox, { onClick: this._setCheckBoxAsRadio }),
                React.createElement("div", { style: {
                        borderLeft: 'solid #FFF',
                        height: '40px',
                        marginLeft: 'auto',
                        marginRight: 'auto'
                    } }, " "),
                React.createElement(ToggleMath
                // @ts-ignore
                , { 
                    // @ts-ignore
                    id: 'toggleMath', checked: this.state.isMath, onChange: this._onMathChange })),
            React.createElement("div", { id: 'chat-input' },
                React.createElement("div", null,
                    React.createElement(Input, { "aria-label": this.props.t('chat.messagebox'), autoFocus: true, className: 'chat-input', id: 'message-input', maxRows: 5, onChange: this._onMessageChange, onKeyPress: this._onDetectSubmit, placeholder: this.props.t('chat.messagebox'), ref: this._textArea, textarea: true, value: this.state.message })),
                React.createElement(Button, { accessibilityLabel: this.props.t('chat.sendButton'), "aria-label": this.props.t('chat.sendButton'), disabled: !this.state.message.trim(), icon: IconSend, id: 'send-chat', onClick: this._onSubmitMessage, size: isMobileBrowser() ? 'large' : 'medium', "tab-index": 0 }))));
    }
    /**
     * Place cursor focus on this component's text area.
     *
     * @private
     * @returns {void}
     */
    _focus() {
        var _a;
        ((_a = this._textArea) === null || _a === void 0 ? void 0 : _a.current) && this._textArea.current.focus();
    }
    _onDisabledToggleMath() {
        // @ts-ignore
        const toggleMath = document.getElementById('toggleMath');
        if (this.state.isTrans == true) {
            // @ts-ignore
            toggleMath.disabled = false;
        }
        else {
            this.setState({ isMath: false });
            // @ts-ignore
            toggleMath.disabled = true;
        }
    }
    /**
     * Submits the message to the chat window.
     *
     * @returns {void}
     */
    _onSubmitMessage() {
        const roomId = location.pathname;
        fetch(`/livi/api/onlineclass/session${roomId}`, {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        }).then((res) => {
            if (res.status === 200) {
                res.json().then((data) => {
                    this.setState({ isTrans: data.translatingType }, () => {
                        const trimmed = this.state.message.trim();
                        const currentLanguage = i18next.language;
                        if (trimmed) {
                            this.props.onSend(trimmed, this.state.isMath, this.state.isBraille, this.state.isTrans, currentLanguage);
                            this.setState({ message: '' });
                            // Keep the textarea in focus when sending messages via submit button.
                            this._focus();
                            this._onDisabledToggleMath();
                        }
                    });
                });
            }
        });
    }
    /**
     * Detects if enter has been pressed. If so, submit the message in the chat
     * window.
     *
     * @param {string} event - Keyboard event.
     * @private
     * @returns {void}
     */
    _onDetectSubmit(event) {
        // Composition events used to add accents to characters
        // despite their absence from standard US keyboards,
        // to build up logograms of many Asian languages
        // from their base components or categories and so on.
        if (event.isComposing || event.keyCode === 229) {
            // keyCode 229 means that user pressed some button,
            // but input method is still processing that.
            // This is a standard behavior for some input methods
            // like entering japanese or сhinese hieroglyphs.
            return;
        }
        // MacOS에서 Alt 포함 단축키 기본 동작 막기 위함
        // TODO: 다른 textarea에서도 막아야함
        if (event.altKey) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (this.state.inputChoice === 'brailleSense') {
            if (event.key === 8 || event.which === 32) {
                return;
            }
            event.preventDefault();
            event.stopPropagation();
            if (this._brailleKeys.includes(event.key)) {
                const elem = {
                    'key': event.key,
                    'timestamp': Date.now()
                };
                console.log(elem);
                this._queue.enqueue(elem);
            }
        }
        if (event.key === 'Enter'
            && event.shiftKey === false
            && event.ctrlKey === false) {
            event.preventDefault();
            event.stopPropagation();
            this._onSubmitMessage();
        }
    }
    /**
     * Updates the known message the user is drafting.
     *
     * @param {string} value - Keyboard event.
     * @private
     * @returns {void}
     */
    _onMessageChange(value) {
        let msg = value;
        if (this.state.inputChoice === 'tapTilo') {
            msg = '';
            for (const v of value) {
                if (v in this._brailleAsciiTable) {
                    msg += this._brailleAsciiTable[v];
                }
                else if (this._brailleList.includes(v)) {
                    msg += v;
                }
            }
        }
        const input = document.getElementById('message-input');
        // @ts-ignore
        const pos = input.selectionStart;
        this.setState({ message: msg }, () => {
            // @ts-ignore
            input.setSelectionRange(pos, pos);
        });
    }
    /**
     * Appends a selected smileys to the chat message draft.
     *
     * @param {string} smileyText - The value of the smiley to append to the
     * chat message.
     * @private
     * @returns {void}
     */
    /// _onSmileySelect(smileyText: string) {
    /* if (smileyText) {
          this.setState({
              message: `${this.state.message} ${smileyText}`,
              showSmileysPanel: false
          });
      } else {
          this.setState({
              showSmileysPanel: false
          });
      }

      this._focus();
  }

  /**
   * Callback invoked to hide or show the smileys selector.
   *
   * @private
   * @returns {void}
   */
    /* _toggleSmileysPanel() {
         if (this.state.showSmileysPanel) {
             this._focus();
         }
         this.setState({ showSmileysPanel: !this.state.showSmileysPanel });
     }*/
    // ts ignore 삭제 필요함
    _setCheckBoxAsRadio(e) {
        // @ts-ignore
        const box = document.getElementById(e.target.id);
        if (box.checked) {
            const group = document.getElementsByName(box.name);
            // @ts-ignore
            for (const g of group) {
                g.checked = false;
            }
            box.checked = true;
            this.setState({
                inputChoice: box.value,
                message: '',
                isBraille: true
            });
        }
        else {
            this.setState({
                inputChoice: '',
                message: '',
                isBraille: false
            });
        }
        // ----------------------------
        // JQuery version is as follows
        // ----------------------------
        // const $box = $(e.target);
        //
        // if ($box.is(':checked')) {
        //     // the name of the box is retrieved using the .attr() method
        //     // as it is assumed and expected to be immutable
        //     const group = `input:checkbox[name='${$box.attr('name')}']`;
        //
        //     // the checked state of the group/box on the other hand will change
        //     // and the current value is retrieved using .prop() method
        //     $(group).prop('checked', false);
        //     $box.prop('checked', true);
        //     this.setState({
        //         inputChoice: $box.val(),
        //         message: '',
        //         isBraille: true
        //     });
        // } else {
        //     $box.prop('checked', false);
        //     this.setState({
        //         inputChoice: '',
        //         message: '',
        //         isBraille: false
        //     });
        // }
    }
    _onMathChange() {
        this.setState({
            isMath: !this.state.isMath
        });
        this.setState({
            message: ''
        });
    }
    _procKeys() {
        if (this.state.inputChoice !== 'brailleSense' || this._queue.isEmpty) {
            return;
        }
        const now = Date.now();
        const diff = now - this._queue.peek().timestamp;
        if (diff < this._inputTh) {
            return;
        }
        let inputs = [];
        while (!this._queue.isEmpty) {
            inputs.push(this._queue.dequeue().key);
        }
        inputs = inputs.sort();
        let pattern = '';
        for (const i of inputs) {
            pattern += i;
        }
        // append a braille glyph
        this.setState({
            message: this.state.message + this._brailleKeyMap[pattern]
        });
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @private
 * @returns {{
 *     _areSmileysDisabled: boolean
 * }}
 */
const mapStateToProps = (state) => {
    return {
    /* _areSmileysDisabled: areSmileysDisabled(state) 에러 주석처리 */
    };
};
export default translate(connect(mapStateToProps)(ChatInput));
